import { Component, inject, Input, OnInit } from '@angular/core';
import { ToastItem } from 'projects/shared/lib/components/shared/toast/item/toast-item.model';
import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { ICartService, ICartServiceToken } from 'projects/shared/lib/services/data/cart/cart-service.interface';
import { EError, EShoppingCartItemValidationError, ProductIdentifierDto, ShoppingCartDto, ShoppingCartItemValidationErrorDto } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { ErrorCodeService } from 'projects/shared/lib/services/infrastructure/error-code.service';
import { ITooltipService, ITooltipServiceToken } from 'shared/services/ui/tooltip/tooltip-service.interface';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';

@Component({
  selector: 'app-cart-preview-item-inactive',
  templateUrl: './cart-preview-item-inactive.component.html',
  standalone: false
})
export class CartPreviewItemInactiveMHComponent implements OnInit {
  private readonly cartService: ICartService = inject(ICartServiceToken);
  private readonly toastService: IToastService = inject(IToastServiceToken);
  private readonly tooltipService: ITooltipService = inject(ITooltipServiceToken);

  @Input() productIdentifier: ProductIdentifierDto | undefined;

  public deleteIconTooltipHtmlContent: string | undefined;
  public shoppingCartItemValidationErrorProductIsInactive: ShoppingCartItemValidationErrorDto;

  public constructor() {
    this.shoppingCartItemValidationErrorProductIsInactive = new ShoppingCartItemValidationErrorDto({
      shoppingCartItemValidationError: EShoppingCartItemValidationError.ProductIsInactive,
    });
  }

  public ngOnInit(): void {
    this.deleteIconTooltipHtmlContent = this.tooltipService.deleteFromCartIconToolTipGet();
  }

  public deleteItem() {
    if (this.productIdentifier == undefined) {
      return;
    }
    this.cartService.cartItemListDeleteAsync([this.productIdentifier]).then(
      (cart: ShoppingCartDto | undefined) => {
        if (!cart) {
          this.toastService.toastItemAdd(new ToastItem({
            type: EToastItemType.Danger,
            title: $localize`:@@CartPreviewItemInactiveDeleteInfoErrorTitle:Failure`,
            message: $localize`:@@CartPreviewItemInactiveDeleteInfoErrorMessage:Item could not be deleted from shopping cart.`,
            code: ErrorCodeService.formatErrorCode(EError.F170021)
          }));
          return;
        }

        if (ENVIRONMENT.cart.shouldValidateCarts != true) {
          return;
        }

        if (this.productIdentifier == undefined) {
          return;
        }
        this.cartService.cartValidationStateSet(undefined, undefined);//.cartItemListValidationDelete([this.productIdentifier]);
      }, () => {
        this.toastService.toastItemAdd(new ToastItem({
          type: EToastItemType.Danger,
          title: $localize`:@@CartPreviewItemInactiveDeleteInfoErrorTitle:Failure`,
          message: $localize`:@@CartPreviewItemInactiveDeleteInfoErrorMessage:Item could not be deleted from shopping cart.`,
          code: ErrorCodeService.formatErrorCode(EError.F170031)
        }));
      }
    );
  }
}
